import { sample, sampleSize, shuffle } from "lodash/fp"
import { IUser } from "../types"

export const getRandomUsers = (users: IUser[], nonIgnoredUsers: IUser[], numberOfUsers = 4): [IUser[], IUser] => {
  const correctUser = sample(nonIgnoredUsers) as IUser
  const randomUsers = shuffle(sampleSize(numberOfUsers - 1, users.filter((user) => user?.mail !== correctUser?.mail)))
  return [randomUsers, correctUser]
}

